<template>
  <div>
    <h2 class="step-name">Email Notifications</h2>

    <div class="step-section" >
      <div v-for="notification in model.notifications" :key="notification.slug">
        <label :class="notification.marked || notification.auto_generated ? '':'comment-disabled'">
          <span class="glyphicon glyphicon-envelope" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Email might be generated"></span>
          {{ notification.name }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'

export default {
  mixins: [ baseComponent ],
  data() {
    return {
      model: {
        notifications: [],
      },
    }
  },
};
</script>
